import { configQuery } from '@gig/magic-common';
import { GEO_TOKEN_QUERY } from '@gig/magic-messages';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class GeoLocationService {
  constructor() {
    this.registerQuerySchema();
    configQuery("geoLocation").then((config) => __async(this, null, function* () {
      if (!config) {
        this.subscribeGeoTokenQueryDisabled();
        return;
      }
      const container = yield import(
        /* webpackChunkName: "geo-location" */
        '@gig/magic-geo-location/dist/service'
      );
      new container.GeoLocationService();
    }));
  }
  subscribeGeoTokenQueryDisabled() {
    window.queryBus.subscribe(GEO_TOKEN_QUERY, () => __async(this, null, function* () {
      return void 0;
    }));
  }
  registerQuerySchema() {
    window.queryBus.register(GEO_TOKEN_QUERY, {
      type: "object",
      required: ["reason"],
      properties: {
        reason: {
          type: "string"
        },
        data: {
          type: "any"
        }
      }
    });
  }
}

export { GeoLocationService };
